import usePageMeta from "../hooks/usePageMeta";

/**
 * Componente wrapper que define titulo e favicon dinamicamente.
 * Uso: <PageMeta title="Dashboard"><Dashboard /></PageMeta>
 */
export default function PageMeta({ title, favicon, children }) {
  usePageMeta(title, favicon);
  return children;
}
